// Social Links Helper
// Centralized functions for filtering social links by display location
// Reduces code duplication across components

import socialLinksData from '../data/socialLinks.json';

/**
 * Get social links that should appear in the sidebar (floating buttons)
 * @returns {Array} Filtered array of social links
 */
export function getSocialLinksForSidebar() {
  return socialLinksData.socialLinks.filter(link => link.showInSocialButtons);
}

/**
 * Get social links that should appear in the contact/socials section
 * @returns {Array} Filtered array of social links
 */
export function getSocialLinksForContact() {
  return socialLinksData.socialLinks.filter(link => link.showInContact);
}

/**
 * Get social links that should appear in the footer
 * @returns {Array} Filtered array of social links
 */
export function getSocialLinksForFooter() {
  return socialLinksData.socialLinks.filter(link => link.showInFooter);
}

/**
 * Get all social links
 * @returns {Array} All social links
 */
export function getAllSocialLinks() {
  return socialLinksData.socialLinks;
}

